export { SparklePlus as default } from './SparklePlus';
